import React, { FunctionComponent } from "react";
import { CellMeasurerCacheParams } from "react-virtualized";

import { DEFAULT_FORM_ITEM_HEIGHT } from "../../constants";
import { MenuNavigationSectionType } from "../../navigation";
import { FormItem } from "../FormItem";
import { MenuComponent } from "../MenuComponent";
import { MenuTitle } from "../MenuTitle";
import { MenuVirtualizedList, MenuVirtualizedListItemRenderer, MenuVirtualizedListKeyGenerator } from "../MenuVirtualizedList";
import { FormMenuComponentProps } from "./FormMenuComponentProps";

export { FormMenuComponentProps };

const cacheParams: CellMeasurerCacheParams = {
    defaultHeight: DEFAULT_FORM_ITEM_HEIGHT,
    minHeight: DEFAULT_FORM_ITEM_HEIGHT,
    fixedWidth: true,
};

/** Komponenta představuje sekci pro formuláře */
export const FormMenuComponent: FunctionComponent<FormMenuComponentProps> = ({
    formItemIds,
    focusedItemIndex,
    title,
}) => (
    <MenuComponent isPlain={true} >
        <MenuVirtualizedList
            items={formItemIds}
            stickyHeaderContent={<MenuTitle text={title} />}
            cellMeasureCacheParams={cacheParams}
            {...{ keyGenerator, itemRenderer, focusedItemIndex }}
        />
    </MenuComponent>
);

const itemRenderer: MenuVirtualizedListItemRenderer<number> = (formItemId) => (
    <FormItem {...{ formItemId }} section={MenuNavigationSectionType.forms} />
);

const keyGenerator: MenuVirtualizedListKeyGenerator<number> = (formItemId) => formItemId.toString();
